import { useEffect } from 'react'

/**
 * Registers test escape hatches on window.__pv2_* only in non-production environments.
 * Pass setter functions from useState calls. When state moves to sub-hooks or
 * contexts in later phases, update the setters passed here and the E2E tests
 * that depend on them will continue working.
 */
export function useTestEscapeHatches(setters: Record<string, unknown>): void {
  useEffect(() => {
    // Block on real production hostname only — tests run against built/preview builds
    if (window.location.hostname === 'primateintelligence.ai') return
    const w = window as unknown as Record<string, unknown>
    for (const [key, fn] of Object.entries(setters)) {
      w[key] = fn
    }
    return () => {
      for (const key of Object.keys(setters)) {
        delete w[key]
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
